import { Component, OnInit } from '@angular/core';
import { Validators, FormBuilder, FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { ReplaySubject, Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { CommonFunction } from 'src/app/grievance/common-function';
import { Board, Departments } from 'src/app/grievance/interface/common-interface';
import { ProjectConstants } from 'src/app/grievance/project-constants';
import { ProgressSpinnerComponent } from 'src/app/progress-spinner/progress-spinner.component';
import { ObjectionSuggestionTypeService } from '../objection-suggestion-type.service';

@Component({
  selector: 'app-update-objection-suggestion',
  templateUrl: './update-objection-suggestion.component.html',
  styleUrls: ['./update-objection-suggestion.component.scss'],
})
export class UpdateObjectionSuggestionComponent implements OnInit {
  levels: any = [];
  objSuggId: any;
  myid: any;
  Excellationdays: any = []
  protected boards: Board[] = [];
  public boardCtrl: FormControl = new FormControl();
  public boardFilterCtrl: FormControl = new FormControl();
  public filteredboards: ReplaySubject<Board[]> = new ReplaySubject<Board[]>(1);
  protected _onDestroy = new Subject<void>();
  isSubmitDisabled: boolean = false
  progressSpinnerDialog: any = null;
  protected departments: Departments[] = [];
  public departmentCtrl: FormControl = new FormControl();
  public departmentFilterCtrl: FormControl = new FormControl();
  public filteredDepartment: ReplaySubject<Departments[]> = new ReplaySubject<Departments[]>(1);
  firstFormGroup = this._formBuilder.group({
    objeSuggestionCtrl: ['', [Validators.required]],
    departmentCtrl: ['', [Validators.required]],
    boardCtrl: [{ value: null }, [Validators.required]],
    osTypeCtrl: ['', [Validators.required]]
  })
  constructor(public _formBuilder: FormBuilder,
    public objectionSuggestionService: ObjectionSuggestionTypeService,
    public activatedRoute: ActivatedRoute,
    public router: Router,
    public dialog: MatDialog,
    private commonFunction: CommonFunction) { }

  async ngOnInit() {
    this.objSuggId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.loadBoards();
    this.viewSingleObjectionType()
  }

  async loadBoards() {
    //call to load board
    // this.displayProgressSpinner();
    const response: any = await this.objectionSuggestionService.loadBoard();
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.boards = response
        //set boards in array  
        this.boardCtrl.setValue(this.boards[10]);
        this.filteredboards.next(this.boards.slice());
        this.boardFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filterboards();
          });
        //
      } else if (response[0].status == ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }


  // filter boards
  protected filterboards() {
    if (!this.boards) {
      return;
    }
    let search = this.boardFilterCtrl.value;
    if (!search) {
      this.filteredboards.next(this.boards.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredboards.next(
      this.boards.filter(board => board.boardName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  async viewSingleObjectionType() {
    this.displayProgressSpinner();
    const response: any = await this.objectionSuggestionService.viewSignleObjSuggestionType(this.objSuggId);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response.status == ProjectConstants.responseStatusSuccess) {
        this.selectBoard(response.fkBdid)
        this.firstFormGroup.setValue({
          departmentCtrl: response.fkDepid,
          objeSuggestionCtrl: response.objectionSuggestion,
          boardCtrl: response.fkBdid,
          osTypeCtrl: response.osType
        })
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }



  //department type filter
  protected filtereDepartments() {
    if (!this.departments) {
      return;
    }
    let search = this.departmentFilterCtrl.value;
    if (!search) {
      this.filteredDepartment.next(this.departments.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredDepartment.next(
      this.departments.filter(grievance => grievance.departmentName.toLowerCase().indexOf(search) > -1)
    );
  }
  //

  async updateForm() {
    if (this.firstFormGroup.valid) {
      const data = {
        'objectionSuggestion': this.firstFormGroup.controls['objeSuggestionCtrl'].value,
        'fkDepid': this.firstFormGroup.controls['departmentCtrl'].value,
        'fkBdid': this.firstFormGroup.controls['boardCtrl'].value,
        'osType': this.firstFormGroup.controls['osTypeCtrl'].value,
        'pkOstid': this.objSuggId
      }
      this.displayProgressSpinner();
      const response: any = await this.objectionSuggestionService.updateObjSuggestionType(data);
      this.progressSpinnerDialog.close()
      if (response != null && !response.error) {
        if(response.status==ProjectConstants.responseStatusSuccess){
          await this.commonFunction.successToast(ProjectConstants.objSuggestionUpdateSuccessMsg,false,"")
          this.router.navigate(['secure/objection-suggestion-type-list'])
        }else{
          await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        }
      } else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
        this.isSubmitDisabled = false
      }
    }
  }

  async displayProgressSpinner() {
    this.progressSpinnerDialog = this.dialog.open(ProgressSpinnerComponent, {
      disableClose: true,
      panelClass: "progressSpinner",
    });
  }


  async selectBoard(boards: any) {
    this.displayProgressSpinner();
    const response: any = await this.objectionSuggestionService.loadDepartments(boards);
    this.progressSpinnerDialog.close()
    if (response != null && !response.error) {
      if (response[0].status == ProjectConstants.responseStatusSuccess) {
        this.departments = response;
        this.departmentCtrl.setValue(this.departments[10]);
        this.filteredDepartment.next(this.departments.slice());
        this.departmentFilterCtrl.valueChanges
          .pipe(takeUntil(this._onDestroy))
          .subscribe(() => {
            this.filtereDepartments();
          })
      }
      else if (response[0].status == ProjectConstants.responseStatusFailure) {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
      else {
        await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
      }
    } else {
      await this.commonFunction.errorToast(ProjectConstants.networkErMsg,false,"")
    }
  }
}
